import { AHText } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { WorkspaceSignalEditMainEditedInfo_Signal$key } from "./__generated__/WorkspaceSignalEditMainEditedInfo_Signal.graphql";
import { FormattedMessage } from "react-intl";
import { FormattedDateInWorkspace } from "../../../../../common/dates/FormattedDate";

export function EditedBy(props: {
  signal: WorkspaceSignalEditMainEditedInfo_Signal$key;
}) {
  const data = useFragment(
    graphql`
      fragment WorkspaceSignalEditMainEditedInfo_Signal on SignalWorkspace {
        updatedBy {
          id
          name
        }
        updatedAtDate {
          ...FormattedDate
        }
      }
    `,
    props.signal
  );

  return (
    <AHText type="detail" spaceRight="small">
      <FormattedMessage
        description="Workspace Signal Edit Edited By"
        defaultMessage="Saved <date>{editedAtDate}</date> by {editedByName}"
        values={{
          editedByName: data.updatedBy?.name ?? "",
          editedAtDate: data.updatedAtDate ? (
            <FormattedDateInWorkspace date={data.updatedAtDate} />
          ) : (
            ""
          ),
          date: (msg) => <>{msg}</>,
        }}
      />
    </AHText>
  );
}
